












import { Component, Inject, Mixins } from 'vue-property-decorator';
import { AxiosInstance as ApiInstance } from 'axios';
import { remoteEduService } from '@/services';
import ExaminationItemModule from '../../examination-item';
import { LoaderMixin } from '@/pages/profile/mixins';
import { IExamination } from './types';

@Component({
  components: {
    ExaminationItemModule,
  },
  metaInfo: () => ({
    title: 'Тест',
  }),
})
export default class ExaminationItem
  extends Mixins(LoaderMixin)
  implements IExamination
{
  @Inject() $api: ApiInstance;

  examination: object = {};

  get id(): string {
    return this.$route.params.id;
  }

  get groupId(): string {
    return this.$route.params.groupId;
  }

  mounted() {
    if (!this.id || !this.groupId) return;
    this.getData();
  }

  async getData() {
    const { $api, id, groupId } = this;
    if (!id) return;
    this.setStatus('loading');
    try {
      const { data } = await remoteEduService($api).getRemoteEduExaminationItem(
        id,
        groupId,
      );
      this.examination = data;
      this.setStatus('success');
    } catch (err) {
      this.setStatus('error');
    }
  }

  async result(val: any) {

    const { $api } = this;
    this.setStatus('loading');
    try {
      const { data } = await remoteEduService(
        $api,
      ).postRemoteEduExaminationItem({ data: val });
      this.setStatus('success');
      // this.getData();
    } catch (err) {
      this.setStatus('error');
    }
  }

  async getResult(result: any) {
    if (result) {
      this.setStatus('success');
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/views/examination-item/examinationItem.vue